import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, Card, Col, Modal, Row, FormGroup} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import PropTypes from 'prop-types';
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {faPlay} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import SearchInput from "./input/SearchInput";

export default class PublishedModelModal extends BaseComponent{

    constructor(props) {
        super(props);
        let state = this.state
        state.models = []
        state.search = ''
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {show} = nextProps
            if(show!=this.props.show && show){
                if(show){
                    this.setState({search:''}, () => {
                        if(show){
                            // window.history.pushState({ show: true }, '');
                            this.handlePopState = (event) =>{
                                if (show) {
                                    this.props.onClose()
                                    // window.history.pushState(null, ''); // re-push state to prevent deep back
                                    window.history.pushState({ show: true }, '');
                                }
                            }
                            window.addEventListener('popstate', this.handlePopState);
                        }else{
                            window.removeEventListener('popstate', this.handlePopState);
                        }
                    })
                }
                this.setState({
                    search:''
                }, () => {
                    this.fetchModels()
                })
            }
        }
    }

    fetchModels = ()=> {
        let {search} = this.state
        let params = {
            search: search,
            sortir : "jm.updated",
            ascending:false
        }
        this.showPostProgress()
        this.get(Endpoint.API.MODELS_PUBLISHED_SIMPLE_PROPERTIES, {params}, null, response=>{
            this.closePostProgress()
            if(response.code===200){
                this.setState({
                    models:response.data
                })
            }else{
                this.errorToast(response.message)
            }
        }, true, true)
    }


    render() {
        let {models, search} = this.state
        let {show, onSelect} = this.props
        if(!models) {
            models = []
        }
        if(!onSelect){
            onSelect = () => {}
        }

        return (
            <>
                {super.render()}
                <Modal
                    as={Modal.Dialog}
                    size="xl" centered show={show} onHide={()=>{}}>
                    <Modal.Header
                        className="bg-light">
                        <Modal.Title className="h6">{label.Models}</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body fluid className="text-center">
                        <Row>
                            <Col>
                                <SearchInput
                                    placeholder={label.SearchModelByNameSystemAndPart}
                                    value={search}
                                    onEnter={(search) => {
                                        this.setState({search}, () => {
                                            this.fetchModels()
                                        })
                                    }}
                                    onEmpty={() => {
                                        this.setState({search:''}, () => {
                                            this.fetchModels()
                                        })
                                    }}/>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            {models.map((item, index)=>{
                                return (
                                    <Col lg={4} md={6} sm={12} xs={12} className="mb-3">
                                        <Card>
                                            <Card.Header className="p-0 bg-info">
                                                <span className="font-small fw-bolder text-white fs-7">{item.modelCategory?item.modelCategory.name:""}</span>
                                            </Card.Header>
                                            <Card.Body>
                                                <Row>
                                                    <Col className="font-small text-center justify-content-center align-content-center align-items-center" md={2} sm={2} xs={2}>
                                                        #{index+1}
                                                    </Col>
                                                    <Col className="text-left justify-content-center align-content-center align-items-center" md={7} sm={7} xs={7}>
                                                        <Row>
                                                            <Col>
                                                                <span className="fw-bolder font-small fs-8">{item.systemType}</span>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col>
                                                                <span className="text-italic text-underline fs-7">{label.PN}:{item.partNumber}</span>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col className="font-small text-center justify-content-center align-content-center align-items-center" md={3} sm={3} xs={3}>
                                                        <Button
                                                            size="sm"
                                                            variant="outline-info"
                                                            className="text-center"
                                                            onClick={e => {
                                                                e.preventDefault()
                                                                onSelect(item)
                                                            }}>
                                                            &nbsp;<FontAwesomeIcon size="sm" icon={faPlay} className="me-1"/>
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                )
                            })
                            }
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
PublishedModelModal.propTypes = {
    show:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    onSelect:PropTypes.func,

}
